export default __webpack_public_path__ + "static/media/ssm_logo.74b7dfd5.png";